module.exports = __webpack_public_path__ + "img/useful-material-element-1.88fe2c98.png";